/**
 * Custom Stats Template
 */

import { escapeHtml, createBlockWrapper } from '../utils';
import { applyThemeOverrides } from './utils';
import { renderIcon } from '../../icons';
import type { TemplateRenderer } from './types';

export const renderCustomStats: TemplateRenderer = (
  config,
  data,
  container,
  _onAction,
  themeOverrides
) => {
  const title = config.title as string | undefined;
  const columns = (config.columns as number) || 4;
  const showTrend = (config.showTrend as boolean) ?? false;

  // Data should have 'items' or 'stats' array
  const items = (data.items || data.stats || []) as Array<{
    value: string | number;
    label: string;
    trend?: string;
    icon?: string;
  }>;

  const wrapper = createBlockWrapper('custom-stats');
  applyThemeOverrides(wrapper, themeOverrides);

  if (title) {
    const titleEl = document.createElement('div');
    titleEl.className = 'pms-custom-stats-title';
    titleEl.textContent = title;
    wrapper.appendChild(titleEl);
  }

  const grid = document.createElement('div');
  grid.className = 'pms-custom-stats-grid';
  grid.style.setProperty('--pms-stats-columns', String(columns));

  for (const item of items) {
    const statEl = document.createElement('div');
    statEl.className = 'pms-custom-stat';

    let html = '';
    const iconSvg = item.icon ? renderIcon(item.icon) : null;
    if (iconSvg) {
      html += `<div class="pms-custom-stat-icon">${iconSvg}</div>`;
    } else if (items.some(i => i.icon)) {
      // Other items have icons — show a default so layout stays consistent
      html += `<div class="pms-custom-stat-icon">${renderIcon('zap')}</div>`;
    }
    html += `<div class="pms-custom-stat-value">${escapeHtml(String(item.value))}</div>`;
    html += `<div class="pms-custom-stat-label">${escapeHtml(item.label)}</div>`;
    if (showTrend && item.trend) {
      const isPositive = item.trend.startsWith('+');
      html += `<div class="pms-custom-stat-trend ${isPositive ? 'pms-trend-up' : 'pms-trend-down'}">${escapeHtml(item.trend)}</div>`;
    }

    statEl.innerHTML = html;
    grid.appendChild(statEl);
  }

  wrapper.appendChild(grid);
  container.appendChild(wrapper);
};
